angular.module 'zc.projects'

.controller 'ConversionTagCtrl',($scope, $translate, Project, MongoConversion, SettingStatus, currentProject) ->
  $scope.conversions = []
  $scope.foundPC = false
  $scope.foundSP = false
  $scope.currentProject = currentProject

  $scope.isDisplayAajsWarningMsg = $scope.currentProject.enable_aajs &&
    _.some([
      $scope.currentProject.site_id,
      $scope.currentProject.tracking_id,
      $scope.currentProject.scope_id
    ],
      (item) => !(item && item.length > 0)
    )

  aideal_cv_var = '' # for embedding as the variable definition
  aideal_cv_var_used = '' # for embedding as the field/value sent as conversions

  if $scope.currentProject.enable_aajs
    scope_id = $scope.currentProject.scope_id || '[scope-id]'
    site_id = $scope.currentProject.site_id || '[site-id]'
    track_id = $scope.currentProject.tracking_id || '[track-id]'
    currency = $scope.currentProject.currency.toUpperCase() || ''
    if $scope.currentProject.enable_direct_cv
      aideal_cv_var = 'var appierRtName = "aideal-cv"; // ' + $translate.instant('projectsSettings.installation.conversionTag.aideal_cv_var_comment', var: 'appierRtName')
      aideal_cv_var_used = '"conversionName": appierRtName, '
      $scope.aideal_cv_var_description1 = $translate.instant('projectsSettings.installation.conversionTag.track_direct_cv_description1', var: 'appierRtName')
      $scope.aideal_cv_var_description2 = $translate.instant('projectsSettings.installation.conversionTag.track_direct_cv_description2', var: 'appierRtName')

    $scope.conversionCode = """
<script>
  var appierRtorderId = "#{$translate.instant('projectsSettings.installation.conversionTag.konbaajon')}"; // #{$translate.instant('projectsSettings.installation.conversionTag.conversionIdComment')}
  var appierRtPrice = "#{$translate.instant('projectsSettings.installation.conversionTag.konbaajon_kingaku')}"; // #{$translate.instant('projectsSettings.installation.conversionTag.conversionPriceComment')}
  #{aideal_cv_var}
  var appierRtItemList = [];
  var appierCouponCode = "";

  //========= #{$translate.instant('projectsSettings.installation.conversionTag.couponCodeCommentRemoveFrom')} =========
  appierCouponCode = "REPLACED_BY_YOUR_COUPON_CODE"; // #{$translate.instant('projectsSettings.installation.conversionTag.couponCodeInstruction')}
  //========= #{$translate.instant('projectsSettings.installation.conversionTag.couponCodeCommentRemoveTo')} =========

  //========= #{$translate.instant('projectsSettings.installation.conversionTag.not_sending_product_comment_from')} =========
  // #{$translate.instant('projectsSettings.installation.conversionTag.hitotsu_me_ikou')}
  appierRtItemList.push(
    {
      // #{$translate.instant('projectsSettings.installation.conversionTag.kaki_tsu_no', count: 3)}
      "productID": "#{$translate.instant('projectsSettings.installation.conversionTag.shouhin')}",
      "unit": "#{$translate.instant('projectsSettings.installation.conversionTag.hanbai_kosuu')}",
      "price": "#{$translate.instant('projectsSettings.installation.conversionTag.shouhin_kingaku')}" // #{$translate.instant('projectsSettings.installation.conversionTag.saigo_no_youso')}
    }
  );
  // #{$translate.instant('projectsSettings.installation.conversionTag.nitsu_me_ikou')}
  appierRtItemList.push(
    {
      // #{$translate.instant('projectsSettings.installation.conversionTag.kaki_tsu_no', count: 3)}
      "productID": "#{$translate.instant('projectsSettings.installation.conversionTag.shouhin')}",
      "unit": "#{$translate.instant('projectsSettings.installation.conversionTag.hanbai_kosuu')}",
      "price": "#{$translate.instant('projectsSettings.installation.conversionTag.shouhin_kingaku')}" // #{$translate.instant('projectsSettings.installation.conversionTag.saigo_no_youso')}
    }
  );
  // #{$translate.instant('projectsSettings.installation.conversionTag.mitsu_me_ikou')}
  //========= #{$translate.instant('projectsSettings.installation.conversionTag.not_sending_product_comment_to')} =========

  //========= #{$translate.instant('projectsSettings.installation.conversionTag.please_do_not_change_below')} =========
  var appierRtCurrency = "#{currency}";
  window.appier_q = window.appier_q || [];
  window.appier_q.push(
    {"t": "register", "content": { "id": "#{scope_id}", "site": "#{site_id}" } },
    {"t": "type_purchase",  "itemList": appierRtItemList, "totalvalue": appierRtPrice, "currency": appierRtCurrency, "action_id": "#{site_id}_Purchase", "track_id": "#{track_id}", "couponCode": appierCouponCode, #{aideal_cv_var_used}"opts": {"uu": appierRtorderId, "action_param1" : JSON.stringify(appierRtItemList), "action_param2": appierRtorderId, "total_revenue" : appierRtPrice, "currency" : appierRtCurrency}}
  );
</script>
<script src="//jscdn.appier.net/aa.js?id=#{site_id}" async></script>
"""
    $scope.conversionOutputCode = """
<script>
  var appierRtorderId = "122321090";
  var appierRtPrice = "3980";
  #{aideal_cv_var}
  var appierRtItemList = [];
  var appierCouponCode = "";

  appierCouponCode = "summer10off";

  appierRtItemList.push(
    {
      "productID": "PSR-22",
      "unit": "1",
      "price": "3980"
    }
  );

  //========= #{$translate.instant('projectsSettings.installation.conversionTag.please_do_not_change_below')} =========
  var appierRtCurrency = "#{currency}";
  window.appier_q = window.appier_q || [];
  window.appier_q.push(
    {"t": "register", "content": { "id": "#{scope_id}", "site": "#{site_id}" } },
    {"t": "type_purchase",  "itemList": appierRtItemList, "totalvalue": appierRtPrice, "currency": appierRtCurrency, "action_id": "#{site_id}_Purchase", "track_id": "#{track_id}", "couponCode": appierCouponCode, #{aideal_cv_var_used}"opts": {"uu": appierRtorderId, "action_param1" : JSON.stringify(appierRtItemList), "action_param2": appierRtorderId, "total_revenue" : appierRtPrice, "currency" : appierRtCurrency}}
  );
</script>
<script src="//jscdn.appier.net/aa.js?id=#{site_id}" async></script>
"""
  else
    if $scope.currentProject.enable_direct_cv
      aideal_cv_var = 'var zenclerk_conversion_name = "aideal-cv"; // ' + $translate.instant('projectsSettings.installation.conversionTag.aideal_cv_var_comment')
      $scope.aideal_cv_var_description1 = $translate.instant('projectsSettings.installation.conversionTag.track_direct_cv_description1', var: 'zenclerk_conversion_name')
      $scope.aideal_cv_var_description2 = $translate.instant('projectsSettings.installation.conversionTag.track_direct_cv_description2', var: 'zenclerk_conversion_name')

    $scope.conversionCode = """
<script type="text/javascript">
  // #{$translate.instant('projectsSettings.installation.conversionTag.conversionIdComment')}
  var zenclerk_conversion_id = "#{$translate.instant('projectsSettings.installation.conversionTag.konbaajon')}";
  // #{$translate.instant('projectsSettings.installation.conversionTag.conversionPriceComment')}
  var zenclerk_conversion_price = "#{$translate.instant('projectsSettings.installation.conversionTag.konbaajon_kingaku')}";
  #{aideal_cv_var}

  // #{$translate.instant('projectsSettings.installation.conversionTag.nini_koodokokokarakokokara_moto')}
  // #{$translate.instant('projectsSettings.installation.conversionTag.shisutemu_mato_ni')}
  // #{$translate.instant('projectsSettings.installation.conversionTag.dore_mo_ireru')}

  var zenclerk_conversion_items = [];
  // #{$translate.instant('projectsSettings.installation.conversionTag.hitotsu_me_ikou')}
  zenclerk_conversion_items.push(
    {
      // #{$translate.instant('projectsSettings.installation.conversionTag.kaki_tsu_no', count: 5)}
      id: "#{$translate.instant('projectsSettings.installation.conversionTag.shouhin')}",
      name: "#{$translate.instant('projectsSettings.installation.conversionTag.shouhinmei')}",
      url: "#{$translate.instant('projectsSettings.installation.conversionTag.shouhinurl')}",
      price: "#{$translate.instant('projectsSettings.installation.conversionTag.shouhin_kingaku')}",
      count: "#{$translate.instant('projectsSettings.installation.conversionTag.hanbai_kosuu')}" // #{$translate.instant('projectsSettings.installation.conversionTag.saigo_no_youso')}
    }
  );
  // #{$translate.instant('projectsSettings.installation.conversionTag.nitsu_me_ikou')}
  zenclerk_conversion_items.push(
    {
      id: "#{$translate.instant('projectsSettings.installation.conversionTag.shouhin')}",
      name: "#{$translate.instant('projectsSettings.installation.conversionTag.shouhinmei')}",
      url: "#{$translate.instant('projectsSettings.installation.conversionTag.shouhinurl')}",
      price: "#{$translate.instant('projectsSettings.installation.conversionTag.shouhin_kingaku')}",
      count: "#{$translate.instant('projectsSettings.installation.conversionTag.hanbai_kosuu')}" // #{$translate.instant('projectsSettings.installation.conversionTag.saigo_no_youso')}
    }
  );
  // #{$translate.instant('projectsSettings.installation.conversionTag.mitsu_me_ikou')}

  // #{$translate.instant('projectsSettings.installation.conversionTag.nini_koodokokomade')}
</script>
"""
    $scope.conversionOutputCode = """
<script type="text/javascript">
  var zenclerk_conversion_id = "122321090";
  var zenclerk_conversion_price = "3980";
  #{aideal_cv_var}
  var zenclerk_conversion_items = [];
  zenclerk_conversion_items.push(
    {
      id: "PSR-22",
      name: "#{$translate.instant('projectsSettings.installation.conversionTag.puriitsusukaato')}",
      url: "http://example.com/item/PSR-22",
      price: "3980",
      count: "1"  // #{$translate.instant('projectsSettings.installation.conversionTag.saigo_no_youso')}
    }
  );
</script>
"""

  $scope.refresh = ->
    MongoConversion.find
      apikey: currentProject.apikey
    ,
      sort:
        created_at: -1
      limit: 10
    .then (conversions) ->
      $scope.foundPC = false
      $scope.foundSP = false
      $scope.conversions = conversions
      for conversion in conversions
        $scope.foundPC = true if conversion.device is 'pc'
        $scope.foundSP = true if conversion.device is 'sp'
  $scope.refresh()

  $scope.updateStatus = (opts) ->
    return if !$scope.foundPC && !$scope.foundSP
    currentProject.conversion_tag_confirmed = true
    Project.update
      projectId: currentProject.id
    ,
      project: currentProject
    .then (result) ->
      currentProject = _.merge(currentProject, result);
      SettingStatus.updateProjectStatus currentProject



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.settings/installation/conversion_tag.controller.coffee